import { render, staticRenderFns } from "./BtnDepressedSmallIconAccept.vue?vue&type=template&id=7955601f"
import script from "./BtnDepressedSmallIconAccept.vue?vue&type=script&lang=js"
export * from "./BtnDepressedSmallIconAccept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports